export default __webpack_public_path__ + "static/media/thumbnail2.1e66c78b.jpg";